function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Select from '../select';
import { ValueContainer } from './Value';
import { Option } from './Option';
import { jsx as ___EmotionJSX } from "@emotion/core";

var CurrencySelector = function CurrencySelector(_ref) {
  var options = _ref.options,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      value = _ref.value,
      css = _ref.css,
      onChange = _ref.onChange,
      otherProps = _objectWithoutProperties(_ref, ["options", "label", "name", "placeholder", "value", "css", "onChange"]);

  return ___EmotionJSX(Select, _extends({
    label: label,
    placeholder: placeholder,
    name: name,
    onChange: onChange,
    css: css,
    options: options,
    value: value,
    components: {
      ValueContainer: ValueContainer,
      Option: Option
    }
  }, otherProps));
};

export default CurrencySelector;